import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { styled, type Theme } from "@mui/material/styles";

/**
 * What the phone's Sort and Filter sheets share (#6715): a bottom sheet with rounded top corners that
 * stops short of the top of the screen, so the list it changes stays in sight above it.
 */
export const sheetPaperSx = (theme: Theme) => ({
  borderTopLeftRadius: theme.spacing(2),
  borderTopRightRadius: theme.spacing(2),
  maxHeight: "85dvh",
  paddingBottom: "env(safe-area-inset-bottom)",
});

const HeadingRow = styled("div")(({ theme }) => ({
  alignItems: "center",
  display: "flex",
  justifyContent: "space-between",
  padding: theme.spacing(1, 1, 0, 2),
}));

export function SheetHeading(props: Readonly<{ id: string; title: string; onClose: () => void }>) {
  return (
    <HeadingRow>
      <Typography id={props.id} variant="h6" component="h2">
        {props.title}
      </Typography>
      <IconButton aria-label={`Close ${props.title.toLowerCase()}`} onClick={props.onClose}>
        <CloseIcon />
      </IconButton>
    </HeadingRow>
  );
}
